module.exports = __webpack_public_path__ + "static/media/Kiosk-Screen2.fbc901d7.png";